import { TaskAdd02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { FC } from "react";
import { Link } from "react-router-dom";

interface BuildSurveyCardProps {
  to: string;
}

export const BuildSurveyCard: FC<BuildSurveyCardProps> = ({ to }) => {
  return (
    <Link
      to={to}
      className="animate-appear flex h-full min-h-0 w-full min-w-0 cursor-pointer flex-col items-center justify-center rounded-lg border border-dashed border-primary-500 bg-primary-20 py-8 text-left transition-colors duration-300 ease-in-out hover:bg-primary-50"
    >
      <span className="flex flex-col items-center justify-center gap-2 text-base font-bold text-primary-500">
        <HugeiconsIcon
          icon={TaskAdd02Icon}
          className="stroke-primary-500"
          size={24}
        />
        Build survey
      </span>
    </Link>
  );
};
